const KNOWN_NOTIFICATION_TYPES = new Set([
  "patient_form_answered",
  "form_answer_created",
  "observer_study_invitation",
  "observer_round_opened",
  "observer_round_schedule_updated",
  "observer_study_terminated",
  "ml_project_shared",
  "ml_project_share_updated",
]);

const OBSERVER_NOTIFICATION_TYPES = new Set([
  "observer_study_invitation",
  "observer_round_opened",
  "observer_round_schedule_updated",
  "observer_study_terminated",
]);

const ML_NOTIFICATION_TYPES = new Set([
  "ml_project_shared",
  "ml_project_share_updated",
]);

function buildInterpolationParams(data = {}) {
  return {
    patientName: data.patientName || "",
    formName: data.formName || "",
    studyTitle: data.studyTitle || "",
    roundNumber: data.roundNumber ?? "",
  };
}

function buildMlInterpolationParams(data = {}, t) {
  const who = data.sharerName
    ? t("notificationTypes.mlDoctorName", { name: data.sharerName })
    : t("notificationTypes.mlColleague");
  const rawTitle = data.projectTitle ? String(data.projectTitle).trim() : "";
  const projectTitle = rawTitle ? `"${rawTitle}"` : t("notificationTypes.mlAProject");
  return { who, projectTitle };
}

export function resolveNotificationTitle(notif, t) {
  const type = notif?.type;
  if (type && KNOWN_NOTIFICATION_TYPES.has(type)) {
    const translated = t(`notificationTypes.${type}.title`);
    if (translated && translated !== `notificationTypes.${type}.title`) {
      return translated;
    }
  }
  return notif?.title || t("newNotification");
}

export function resolveNotificationMessage(notif, t) {
  const type = notif?.type;
  const params = buildInterpolationParams(notif?.data);

  if (type && OBSERVER_NOTIFICATION_TYPES.has(type)) {
    const translated = t(`notificationTypes.${type}.message`, params);
    if (translated && translated !== `notificationTypes.${type}.message`) {
      return translated;
    }
  }

  if (type && ML_NOTIFICATION_TYPES.has(type)) {
    const mlParams = buildMlInterpolationParams(notif?.data, t);
    const translated = t(`notificationTypes.${type}.message`, mlParams);
    if (translated && translated !== `notificationTypes.${type}.message`) {
      return translated;
    }
  }

  if (
    type &&
    KNOWN_NOTIFICATION_TYPES.has(type) &&
    params.patientName &&
    params.formName
  ) {
    const translated = t(`notificationTypes.${type}.message`, params);
    if (translated && translated !== `notificationTypes.${type}.message`) {
      return translated;
    }
  }
  return notif?.message || "";
}
